import http from '@/utils/request';

// ip配置列表
export const getIpProxyConfigList = (data = {}) => {
  const url = '/channel/ipProxyConfig/list';
  return http.post({
    url,
    data,
  });
};
// ip配置-停用启用
export const setIpProxyConfigBindEip = (data = {}) => {
  const url = '/channel/ipProxyConfig/bindEip';
  return http.post({
    url,
    data,
  });
};
// ip配置-编辑
export const setIpProxyConfigEditRemark = (data = {}) => {
  const url = '/channel/ipProxyConfig/editRemark';
  return http.post({
    url,
    data,
  });
};

// ip配置-获取绑定列表
export const getIpProxyConfigEcsList = (data = {}) => {
  const url = '/channel/ipProxyConfig/getEcsList';
  return http.post({
    url,
    data,
  });
};
